module.exports = __webpack_public_path__ + "img/03.b6ee9584.jpg";